import React from 'react'
import {Switch} from 'react-router-dom'
import CustomRoute from 'components/core/CustomRoute'
import Menu from 'components/Menu'
import MenuLanguageSwitch from 'components/Menu/MenuLanguageSwitch'


const Routes = ({props}) => {
  return <Switch>
    <CustomRoute pageTitle = {''} path='/' component={Menu} exact/>
    <CustomRoute pageTitle={'Menu'} path='/menu/:lang' component={MenuLanguageSwitch}/>
  </Switch>
}

export default Routes